import type { TrackConversionEventParams } from "@circle-react/api/conversionTrackingApi";
import { amount } from "@circle-react/helpers/paywalls/currencies";

export const buildMetaFunnelEvent = (
  params: TrackConversionEventParams,
  pixelId?: string,
) => ({
  eventName: params.eventName,
  dedupKey: params.fireNonce
    ? `${params.funnelUuid}:${params.fireNonce}`
    : params.funnelUuid,
  pixelId,
  value:
    params.value !== undefined && params.currencySmallestUnit
      ? amount({ smallest_unit: params.currencySmallestUnit }, params.value)
      : undefined,
  currency: params.currency?.toUpperCase(),
  paymentType: params.paymentType,
});
